"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagKE = function FlagKE(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v82.39H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.94",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.94",
    y: "85.75",
    width: "409.6",
    height: "14.13",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.94",
    y: "170.49",
    width: "409.6",
    height: "14.13",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.61-47.33C55.3-59,61.23-86.21,61.23-86.21S43.58-64.74,37.89-53a6.48,6.48,0,0,0,1,7.19L-25.85,87.73l4.4,2.13L43.32-43.68a6.51,6.51,0,0,0,6.29-3.65Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-26-47.33C-31.7-59-37.63-86.21-37.63-86.21S-20-64.74-14.29-53a6.5,6.5,0,0,1-1,7.19L49.45,87.73l-4.4,2.13L-19.72-43.68A6.54,6.54,0,0,1-26-47.33Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.11,12.18c0,39-28.81,70.62-35.31,70.62S-23.51,51.18-23.51,12.18,5.3-58.44,11.8-58.44,47.11-26.82,47.11,12.18Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#c8414b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.05,46.25a89.81,89.81,0,0,0,7.06-34.07,89.81,89.81,0,0,0-7.06-34.07A89.82,89.82,0,0,0,33,12.18a89.82,89.82,0,0,0,7.07,34.07Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-16.45-21.89a89.81,89.81,0,0,0-7.06,34.07,89.86,89.86,0,0,0,7.06,34.07A89.81,89.81,0,0,0-9.39,12.18a89.81,89.81,0,0,0-7.06-34.07Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.86,12.18c0,5.85-3.16,10.59-7.06,10.59S4.74,18,4.74,12.18,7.9,1.59,11.8,1.59s7.06,4.74,7.06,10.59Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.86-58.44v60c1.92-4,5.34-15.86,5.34-30s-3.42-26-5.34-30Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.74-58.44c-1.92,4-5.34,15.85-5.34,30s3.42,26,5.34,30Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.86,22.77v60c1.92-4,5.34-15.85,5.34-30s-3.42-26-5.34-30Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.74,22.77c-1.92,4-5.34,15.86-5.34,30s3.42,26,5.34,30Zm0,0",
    transform: "translate(193.94 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagKE;
exports["default"] = _default;